// @ts-nocheck
import React from "react";
import { useDispatch } from "react-redux";
import { fetchUnreadMsgChatRoomsCountAction } from "../../store/actions/groupMessagingActions";

const useFetchUnreadMsgChatRoomsCount = () => {

  // redux hooks start...
  const dispatch = useDispatch();
  // redux hooks end...

  // useEffect start...
  React.useEffect(() => {
    dispatch(
      fetchUnreadMsgChatRoomsCountAction()
    )
  }, []);
  // useEffect end...

  return null;
}

export default useFetchUnreadMsgChatRoomsCount;